/* ==========================================================================
   LES FRILEUX — THEME.JS
   Aucune dépendance, aucune bibliothèque. Vanilla, ~10 ko non minifié.
   Modules : tiroirs · en-tête · annonce · galerie · variantes · panier
             · barre d'achat collante · toast
   ========================================================================== */
(function () {
  'use strict';

  var LF = window.LF || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var money = function (cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: LF.currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  };
  var emit = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); };

  /* ------------------------------------------------------------- TOAST */
  var toastEl = null, toastTimer = null;
  function toast(message) {
    toastEl = toastEl || $('[data-lf-toast]');
    if (!toastEl || !message) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3200);
  }

  /* ------------------------------------------------------------ TIROIRS */
  var Drawers = {
    current: null,
    lastFocus: null,
    open: function (name) {
      var el = $('[data-lf-drawer="' + name + '"]');
      if (!el) return;
      this.lastFocus = document.activeElement;
      this.current = el;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      var ov = $('[data-lf-overlay]');
      if (ov) { ov.hidden = false; requestAnimationFrame(function () { ov.classList.add('is-open'); }); }
      document.body.classList.add('lf-no-scroll');
      $$('[data-lf-open="' + name + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var focusable = el.querySelector('button, [href], input, select, textarea');
      (focusable || el).focus();
      emit('lf:drawer:open', { name: name });
    },
    close: function () {
      if (!this.current) return;
      var el = this.current;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      var ov = $('[data-lf-overlay]');
      if (ov) {
        ov.classList.remove('is-open');
        setTimeout(function () { ov.hidden = true; }, 220);
      }
      document.body.classList.remove('lf-no-scroll');
      $$('[aria-expanded="true"][data-lf-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      this.current = null;
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },
    trap: function (e) {
      if (!this.current || e.key !== 'Tab') return;
      var items = $$('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])', this.current)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-lf-open]');
    if (opener) {
      var name = opener.getAttribute('data-lf-open');
      if (name === 'cart' && LF.cartMode === 'page') return; // laisse le lien agir
      e.preventDefault();
      Drawers.open(name);
      return;
    }
    if (e.target.closest('[data-lf-close]') || e.target.closest('[data-lf-overlay]')) {
      e.preventDefault();
      Drawers.close();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') Drawers.close();
    Drawers.trap(e);
  });

  /* ------------------------------------------------------------- EN-TÊTE */
  (function () {
    var header = $('[data-lf-header]');
    if (!header || header.getAttribute('data-hide-on-scroll') !== 'true') return;
    var last = 0, ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY;
        if (y > last && y > 200 && !Drawers.current) header.classList.add('is-hidden');
        else header.classList.remove('is-hidden');
        last = y;
        ticking = false;
      });
    }, { passive: true });
  })();

  /* ----------------------------------------------------- BANDEAU ANNONCE */
  (function () {
    var bar = $('[data-lf-announcement]');
    if (!bar) return;
    var items = $$('.lf-announcement__item', bar);
    if (items.length < 2) return;
    var i = 0, interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
    setInterval(function () {
      if (window.matchMedia('(min-width: 900px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  })();

  /* -------------------------------------------------------------- PANIER */
  var Cart = {
    fetching: false,
    async add(formData, button) {
      var label = button ? button.innerHTML : null;
      if (button) { button.classList.add('is-loading'); button.innerHTML = LF.strings.adding || 'Ajout en cours…'; }
      try {
        var res = await fetch(LF.routes.cartAdd, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || LF.strings.error);
        emit('lf:cart:added', { items: data.items || [data] });
        await this.refresh();
        if (LF.cartMode === 'page') { window.location.href = LF.routes.cart; return; }
        Drawers.open('cart');
      } catch (err) {
        toast(err.message || LF.strings.error);
      } finally {
        if (button && label !== null) { button.classList.remove('is-loading'); button.innerHTML = label; }
      }
    },
    async change(line, quantity) {
      if (this.fetching) return;
      this.fetching = true;
      try {
        var res = await fetch(LF.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.message || LF.strings.error);
        await this.refresh();
        emit('lf:cart:updated', data);
      } catch (err) {
        toast(err.message || LF.strings.error);
      } finally {
        this.fetching = false;
      }
    },
    async refresh() {
      var res = await fetch(LF.routes.root + '?section_id=cart-drawer');
      var html = await res.text();
      var wrapper = document.getElementById('shopify-section-cart-drawer');
      if (wrapper) {
        var wasOpen = !!wrapper.querySelector('.is-open');
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#shopify-section-cart-drawer') || tmp.firstElementChild;
        wrapper.innerHTML = fresh.innerHTML;
        if (wasOpen) {
          var drawer = wrapper.querySelector('[data-lf-drawer="cart"]');
          if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); Drawers.current = drawer; }
        }
      }
      // Compteur d'en-tête + éventuelle page panier
      var cartRes = await fetch(LF.routes.cart + '.js');
      var cart = await cartRes.json();
      $$('[data-lf-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.setAttribute('data-count', cart.item_count);
      });
      $$('[data-lf-cart-count-label]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
      var pageWrap = document.querySelector('[data-lf-cart-page]');
      if (pageWrap) {
        var pageRes = await fetch(LF.routes.cart + '?section_id=main-cart');
        var pageHtml = await pageRes.text();
        var t2 = document.createElement('div');
        t2.innerHTML = pageHtml;
        var f2 = t2.querySelector('[data-lf-cart-page]');
        if (f2) pageWrap.innerHTML = f2.innerHTML;
      }
      window.LF.cart = cart;
      return cart;
    }
  };
  window.LFCart = Cart;

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lf-product-form]');
    if (!form) return;
    e.preventDefault();
    Cart.add(new FormData(form), form.querySelector('[type="submit"]'));
  });

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-lf-qty-change]');
    if (step) {
      var wrap = step.closest('[data-lf-qty]');
      var input = wrap.querySelector('[data-lf-qty-input]');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-lf-qty-change'), 10));
      input.value = next;
      if (input.hasAttribute('data-line-index')) Cart.change(parseInt(input.getAttribute('data-line-index'), 10), next);
      return;
    }
    var remove = e.target.closest('[data-lf-remove]');
    if (remove) {
      e.preventDefault();
      Cart.change(parseInt(remove.getAttribute('data-line-index'), 10), 0);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lf-qty-input][data-line-index]');
    if (!input) return;
    Cart.change(parseInt(input.getAttribute('data-line-index'), 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ------------------------------------------------ SÉLECTION DE VARIANTE */
  function ProductForm(root) {
    var dataEl = root.querySelector('[data-lf-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector('[data-lf-variant-id]');
    var priceEl = root.querySelector('[data-lf-price]');
    var submit = root.querySelector('[data-lf-submit]');
    var skuEl = root.querySelector('[data-lf-sku]');
    var selected = {};

    root.querySelectorAll('[data-lf-option]').forEach(function (el) {
      if (el.getAttribute('aria-checked') === 'true') selected[el.getAttribute('data-lf-option')] = el.getAttribute('data-value');
    });

    function match() {
      return variants.find(function (v) {
        return Object.keys(selected).every(function (pos) { return v['option' + pos] === selected[pos]; });
      });
    }

    function availableFor(position, value) {
      var probe = Object.assign({}, selected);
      probe[position] = value;
      return variants.some(function (v) {
        return v.available && Object.keys(probe).every(function (pos) { return v['option' + pos] === probe[pos]; });
      });
    }

    function render() {
      root.querySelectorAll('[data-lf-option]').forEach(function (el) {
        var pos = el.getAttribute('data-lf-option'), val = el.getAttribute('data-value');
        el.setAttribute('aria-checked', selected[pos] === val ? 'true' : 'false');
        el.setAttribute('data-available', availableFor(pos, val) ? 'true' : 'false');
      });

      var v = match();
      if (!v) {
        if (submit) { submit.setAttribute('disabled', 'disabled'); submit.textContent = LF.strings.unavailable; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span class="lf-price' + (v.compare_at_price > v.price ? ' lf-price--sale' : '') + '">';
        if (v.compare_at_price > v.price) html += '<span class="lf-price__was">' + money(v.compare_at_price) + '</span>';
        html += money(v.price) + '</span>';
        priceEl.innerHTML = html;
      }
      if (skuEl) skuEl.textContent = v.sku || '';
      /* Le libellé du coloris restait sur la valeur d'ouverture : on cliquait
         « Cerisier », la fiche continuait d'afficher « Graphite » alors que la
         variante ajoutée au panier était la bonne. */
      var colorLabel = root.querySelector('[data-lf-color-label]');
      if (colorLabel) {
        root.querySelectorAll('[data-lf-option]').forEach(function (el) {
          if (el.getAttribute('aria-checked') !== 'true') return;
          var group = el.closest('.lf-buy__group');
          if (group && group.querySelector('[data-lf-color-label]')) {
            colorLabel.textContent = el.getAttribute('data-value');
          }
        });
      }
      if (submit) {
        if (v.available) { submit.removeAttribute('disabled'); submit.textContent = submit.getAttribute('data-label-default'); }
        else { submit.setAttribute('disabled', 'disabled'); submit.textContent = LF.strings.soldOut; }
      }
      // Sticky
      var sticky = document.querySelector('[data-lf-sticky-price]');
      if (sticky) sticky.textContent = money(v.price);
      var stickyId = document.querySelector('[data-lf-sticky-variant]');
      if (stickyId) stickyId.value = v.id;
      // Galerie : aller à l'image de la variante
      if (v.featured_media_position) {
        var slides = root.closest('.lf-product, body').querySelector('[data-lf-slides]');
        if (slides) {
          var target = slides.children[v.featured_media_position - 1];
          if (target) slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
        }
      }
      // URL
      if (history.replaceState && root.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      emit('lf:variant:change', { variant: v, product: root.getAttribute('data-product-title') });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-lf-option]');
      if (!opt || opt.getAttribute('data-available') === 'false' && opt.hasAttribute('data-hard-disabled')) return;
      selected[opt.getAttribute('data-lf-option')] = opt.getAttribute('data-value');
      render();
    });
    root.addEventListener('keydown', function (e) {
      var opt = e.target.closest('[data-lf-option]');
      if (!opt || (e.key !== ' ' && e.key !== 'Enter')) return;
      e.preventDefault();
      opt.click();
    });

    render();
  }
  $$('[data-lf-product]').forEach(ProductForm);

  /* ------------------------------------------------------------- GALERIE */
  $$('[data-lf-gallery]').forEach(function (gal) {
    var slides = gal.querySelector('[data-lf-slides]');
    var dots = $$('[data-lf-dot]', gal);
    var thumbs = $$('[data-lf-thumb]', gal);
    if (!slides) return;
    function goTo(i) {
      var target = slides.children[i];
      if (target) slides.scrollTo({ left: target.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    slides.addEventListener('scroll', function () {
      var i = Math.round(slides.scrollLeft / slides.clientWidth);
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }, { passive: true });
  });

  /* --------------------------------------------- BARRE D'ACHAT COLLANTE */
  (function () {
    var sticky = $('[data-lf-sticky-atc]');
    var anchor = $('[data-lf-atc-anchor]');
    if (!sticky || !anchor || !('IntersectionObserver' in window)) return;
    /* La barre est en position fixed : elle ne réserve aucune place. En bas de
       page elle recouvrait la dernière ligne du pied de page. On réserve la
       hauteur correspondante sur la page tant qu'une barre existe. */
    document.body.classList.add('lf-has-sticky-atc');
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        if (show && !sticky.dataset.seen) { sticky.dataset.seen = '1'; emit('lf:sticky:shown', {}); }
      });
    }, { threshold: 0 }).observe(anchor);
  })();

  /* ------------------------------------------------ INTERACTIONS SUIVIES */
  document.addEventListener('toggle', function (e) {
    var d = e.target.closest('details[data-lf-track]');
    if (d && d.open) emit('lf:interaction', { name: d.getAttribute('data-lf-track') });
  }, true);

  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-lf-track-click]');
    if (el) emit('lf:interaction', { name: el.getAttribute('data-lf-track-click') });
  });

  /* --------------------------------- HERO : froid → emmitouflé → au chaud
     Trois attributs qui changent, rien de plus. Coupé net si le visiteur a
     demandé moins d'animations. La page reste lisible et complète sans JS. */
  (function () {
    var masc = document.querySelector('.lf-boom__masc');
    if (!masc) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var use   = masc.querySelector('use');
    var frost = document.querySelector('[data-lf-frost]');
    var reply = document.querySelector('[data-lf-reply]');
    if (!use) return;
    var cycle = [
      { id: '#lfm-grelotte',    shiver: true,  frost: '1',   reply: '0' },
      { id: '#lfm-emmitouflee', shiver: false, frost: '.35', reply: '0' },
      { id: '#lfm-chaud',       shiver: false, frost: '0',   reply: '1' }
    ];
    var i = 0;
    setInterval(function () {
      i = (i + 1) % cycle.length;
      var s = cycle[i];
      use.setAttribute('href', s.id);
      masc.classList.toggle('lf-masc--shiver', s.shiver);
      if (frost) frost.style.opacity = s.frost;
      if (reply) reply.style.opacity = s.reply;
    }, 4200);
  })();

  window.LFToast = toast;
})();
